import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';
import { MediaQueryProvider, ThemeProvider } from '@cbhq/cds-web/system';
import { coinbaseTheme } from '@cbhq/cds-web/themes/coinbaseTheme';
import { TextBody } from '@cbhq/cds-web/typography';

import { TokenRoute } from './routes/TokenRoute';

function Home() {
  return (
    <VStack alignItems="center" justifyContent="center" height="100vh">
      <TextBody>👍</TextBody>
    </VStack>
  );
}

export function App() {
  return (
    <MediaQueryProvider>
      <ThemeProvider theme={coinbaseTheme} activeColorScheme="light" isolated>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:token" element={<TokenRoute />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </MediaQueryProvider>
  );
}
